import { useSnackbar } from "../../../utils/notificacoes"
import React, { useCallback, useEffect, useReducer, useState } from "react"
import {
    obterRespostasIzza,
    salvarRespostasIzza,
} from "../../../services/respostasPersonalizadasIzza"
import useLoadingStore from "../../../stores/LoadingStore"
import useAppStore from "../../../stores/AppStore"
import { Loading } from "../../RegistradorDePedidos"
import { RespostasPersonalizadasIzzaInicial } from "../models/respostasPersonalizadasIzzaModel"
import { RespostasPersonalizadasIzzaActionsTypes } from "./respostasPersonalizadasIzzaActions"
import { RespostasPersonalizadasIzzaContext } from "./RespostasPersonalizadasIzzaContext"
import { respostasPersonalizadasIzzaReducer } from "./respostasPersonalizadasIzzaReducer"

export function RespostasPersonalizadasIzzaContextProvider({
    children,
}: {
    children: React.ReactNode
}) {
    const [dados, dispatch] = useReducer(
        respostasPersonalizadasIzzaReducer,
        RespostasPersonalizadasIzzaInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)
    const perfil = useAppStore(s => s.configuracoes?.user?.perfil)
    const ehClienteFiel = perfil === "CLIENTEFIEL"
    const { enqueueSnackbar } = useSnackbar()

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterRespostasIzza(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: RespostasPersonalizadasIzzaActionsTypes.CARREGAR,
                    payload: response,
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const { modoIzza, ...rest } = dados
            // Modo da Izza só é enviado (e alterado) por perfil CLIENTEFIEL; demais são somente leitura.
            const payload = ehClienteFiel ? { ...rest, modoIzza } : rest
            const response = await salvarRespostasIzza(autorizacao, payload)
            if (typeof response === "object" && "retornoErro" in response) {
                enqueueSnackbar(response.mensagem || "Erro ao salvar", { variant: "error" })
            } else {
                enqueueSnackbar("Mensagens atualizadas com sucesso!", { variant: "success" })
                // Recarrega para refletir os ids/estado persistidos e evitar reenvio defasado.
                await carregar()
            }
        } catch {
            enqueueSnackbar("Erro ao salvar", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }, [dados, ehClienteFiel])

    return (
        <RespostasPersonalizadasIzzaContext.Provider
            value={{ dados, dispatch, erroCarregamento, salvar }}
        >
            <Loading />
            {children}
        </RespostasPersonalizadasIzzaContext.Provider>
    )
}
